import { render, staticRenderFns } from "./UnpairedDatasetElementView.vue?vue&type=template&id=faf6edae&scoped=true"
import script from "./UnpairedDatasetElementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnpairedDatasetElementView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UnpairedDatasetElementView.vue?vue&type=style&index=0&id=faf6edae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf6edae",
  null
  
)

export default component.exports